function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { InputDropdown } from '../index'; // TODO: Consider deprecating read-only Dropdown in favor of Select component

var usStates = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

class StatesDropdown extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      value: this.props.value,
      initialValue: this.props.value
    });

    _defineProperty(this, "handleOnChange", change => {
      this.setState({
        value: change.value
      }, () => {
        this.props.onChange(change);
      });
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(InputDropdown, _extends({}, this.props, {
      value: this.state.value,
      itemList: usStates,
      onChange: this.handleOnChange
    }));
  }

}

_defineProperty(StatesDropdown, "getDerivedStateFromProps", (nextProps, prevState) => {
  if (nextProps.value === prevState.initialValue) {
    return null;
  }

  return {
    value: nextProps.value
  };
});

export default StatesDropdown;